module.exports = __webpack_public_path__ + "media/images/about-us/instragram-09c0bbf573a3f3c0e9c0af7b09fbb719.svg";